import { render, staticRenderFns } from "./BridgeLoot.vue?vue&type=template&id=529ead0f&scoped=true&"
import script from "./BridgeLoot.vue?vue&type=script&lang=js&"
export * from "./BridgeLoot.vue?vue&type=script&lang=js&"
import style0 from "./BridgeLoot.vue?vue&type=style&index=0&id=529ead0f&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "529ead0f",
  null
  
)

export default component.exports